const SectionMain = (props) => {
    return (
        <div
            className="sectionContainer-main contentAreaWrap"
            data-testid="section-main"
        >
            {props.children}
        </div>
    );
};

export default SectionMain;
